exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container[data-v-1e2dcd22]{min-height:100%;width:100%;background-color:#f2f2f2;overflow:hidden}.login-container .box-card[data-v-1e2dcd22]{width:400px;max-width:100%;padding:20px 35px 0;margin:0 auto;overflow:hidden;position:absolute;top:20%;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%)}.login-container .svg-container[data-v-1e2dcd22]{padding:6px 5px 6px 15px;color:#889aa4;vertical-align:middle;width:30px;display:inline-block}\n", ""]);

// exports
